require('./pensionPlanPeriodicCancelSummary.scss');

// @vendor
const React = require('react');
const { withRouter } = require('react-router-dom');
const PropTypes = require('prop-types');

// @helpers
const { FormattedText } = require('core/i18n').i18n;
const { BROKER_PLAN_CANCEL_CONTRIBUTION_ID } = require('constants/operationTypes');
const {
    MYPROFILE_BROKER_PENSION_PLAN_PERIODICAL_CONTRIBUTION_URL
} = require('constants/index');

// @components
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKLink } = require('commonsComponents/OKLink');
const SignaturePattern = require('components/signaturePattern/signaturePattern').SignaturePattern;
const PensionPlanPeriodicCancelDataTable = require('components/broker/brokerPensionPlanContribution/pensionPlanPeriodic/pensionPlanPeriodicCancelDataTable/pensionPlanPeriodicCancelDataTable');

class BrokerPensionPlanPeriodicCancelSummary extends React.Component {

    constructor(props) {
        super(props);
        this.handleValidatePeriodicCancelContribution = this.handleValidatePeriodicCancelContribution.bind(this);
    }

    createFooter(operationType, operationParams) {
        return (
            <footer>
                <section className="pension-plan-periodic-cancel-summary__signature-pattern-section">
                    <SignaturePattern
                        operationType={operationType}
                        operationParams={operationParams}
                    />
                </section>
            </footer>
        );
    }

    handleValidatePeriodicCancelContribution () {
        const { plan, validatePeriodicCancelContribution, history } = this.props;
        validatePeriodicCancelContribution(plan, history);
    }

    render() {
        const { plan, immBrokerPensionPlanPeriodicalContribution } = this.props;
        const product = plan.getIn(['contrato','producto']);
        const contractNumber = plan.getIn(['contrato','numerodecontrato']);
        const chargeAccount = plan.getIn(['cuentaAsociada','codbban']).substring(0,8) + product + contractNumber;
        const operationType = BROKER_PLAN_CANCEL_CONTRIBUTION_ID;
        const operationParams = {
            'originAccount': chargeAccount
        };
        const cancelPeriodicPlanUrl = MYPROFILE_BROKER_PENSION_PLAN_PERIODICAL_CONTRIBUTION_URL;
        const infoPlan = (
            <PensionPlanPeriodicCancelDataTable
                plan={plan}
                immBrokerPensionPlanPeriodicalContribution={immBrokerPensionPlanPeriodicalContribution}
            />
        );

        return (
            <div className="pension-plan-periodic-cancel-summary">
                <header className="pension-plan-periodic-cancel-summary__header">
                    <h2 className="pension-plan-periodic-cancel-summary__title broker-pension-plan-periodic-cancel-summary__title">
                        <FormattedText value="pensionPlanContribution-step2Title" />
                    </h2>
                    <p className="pension-plan-periodic-cancel-summary__subtitle">
                        <FormattedText value="pensionPlanContribution-step2SubTitle" />
                    </p>
                </header>
                <section>
                    {infoPlan}
                </section>
                {this.createFooter(operationType, operationParams)}
                <footer className="pension-plan-periodic-cancel-summary__footer">
                    <div className="pull-left">
                        <OKLink
                            modifier="inherit-styles"
                            to={cancelPeriodicPlanUrl}
                        >
                            <FormattedText value="common-cancel" />
                        </OKLink>
                    </div>
                    <div className="pull-right">
                        <OKButton onClick={this.handleValidatePeriodicCancelContribution} typeButton="submit">
                            <FormattedText value="common-confirm" />
                        </OKButton>
                    </div>
                </footer>
            </div>
        );
    }
}

BrokerPensionPlanPeriodicCancelSummary.propTypes = {
    history: PropTypes.object.isRequired,
    plan: PropTypes.object.isRequired,
    validatePeriodicCancelContribution: PropTypes.func.isRequired,
    immBrokerPensionPlanPeriodicalContribution: PropTypes.object.isRequired
};

module.exports = withRouter(BrokerPensionPlanPeriodicCancelSummary);
